/**
 * Event Configurator — SCAVI & RAY
 * Shopify Section JavaScript
 *
 * Expects a global `window.ecConfig` object set by the Liquid template
 * containing product data, images, and texts.
 */
(function () {
  'use strict';

  const cfg = window.ecConfig;
  if (!cfg) return;

  const root = document.getElementById('ec-' + cfg.sectionId);
  if (!root) return;

  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => root.querySelectorAll(sel);

  // ── State ──
  var STORAGE_KEY = 'ec-state-' + cfg.sectionId;
  const state = { occasion: null, guests: null, taste: null, step: 1 };
  let currentItems = [];
  let totalBoxes = 0;

  // ── Persist State ──
  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function loadState() {
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed && parsed.step) {
          state.occasion = parsed.occasion || null;
          state.guests = parsed.guests || null;
          state.taste = parsed.taste || null;
          state.step = parsed.step || 1;
          return true;
        }
      }
    } catch (e) {}
    return false;
  }

  function restoreUI() {
    if (state.occasion) {
      var occasionCard = root.querySelector('.ec-option[onclick*="\'occasion\',\'' + state.occasion + '\'"]');
      if (occasionCard) {
        occasionCard.classList.add('selected');
        var btn1 = $('#ec-next-1');
        if (btn1) btn1.disabled = false;
      }
    }
    if (state.guests) {
      var guestCard = root.querySelector('.ec-guest[onclick*="\'' + state.guests + '\'"]');
      if (guestCard) {
        guestCard.classList.add('selected');
        var btn2 = $('#ec-next-2');
        if (btn2) btn2.disabled = false;
      }
    }
    if (state.taste) {
      var tasteCard = root.querySelector('.ec-option[onclick*="\'taste\',\'' + state.taste + '\'"]');
      if (tasteCard) {
        tasteCard.classList.add('selected');
        var btn3 = $('#ec-next-3');
        if (btn3) btn3.disabled = false;
      }
    }

    $$('.ec-step').forEach(function (s) { s.classList.remove('active'); });
    var targetStep = $('[data-step="' + state.step + '"]');
    if (targetStep) targetStep.classList.add('active');
    updateProgress(state.step);

    if (state.step === 4 && state.taste) {
      showResult();
    }
  }

  const products = cfg.products;

  // ── Recommendation Logic ──
  function getRecommendation() {
    const { occasion, guests, taste } = state;

    if (occasion === 'jga') {
      var jgaQty = cfg.jgaQty || 1;
      if (taste === 'sweet') return [{ product: 'hugo', qty: jgaQty }];
      if (taste === 'dry') return [{ product: 'premium', qty: jgaQty }];
      if (taste === 'mixed') {
        var jgaPremium = Math.ceil(jgaQty / 2);
        var jgaHugo = Math.max(1, Math.floor(jgaQty / 2));
        return [{ product: 'premium', qty: jgaPremium }, { product: 'hugo', qty: jgaHugo }];
      }
    }

    if (occasion === 'wedding') {
      const sizes = {
        s: cfg.weddingSQty || 3,
        m: cfg.weddingMQty || 6,
        l: cfg.weddingLQty || 10
      };
      const total = sizes[guests];
      if (taste === 'sweet') return [{ product: 'hugo', qty: total }];
      if (taste === 'dry') return [{ product: 'premium', qty: total }];
      if (taste === 'mixed') {
        const premiumQty = Math.ceil(total / 2);
        const hugoQty = Math.floor(total / 2);
        return [{ product: 'premium', qty: premiumQty }, { product: 'hugo', qty: hugoQty }];
      }
    }
    return [];
  }

  // ── Selection ──
  function selectOption(key, value, el) {
    state[key] = value;
    el.parentElement.querySelectorAll('.ec-option, .ec-guest').forEach(function (c) {
      c.classList.remove('selected');
    });
    el.classList.add('selected');

    var stepEl = el.closest('.ec-step');
    var stepNum = stepEl.getAttribute('data-step');
    var nextBtn = $('#ec-next-' + stepNum);
    if (nextBtn) nextBtn.disabled = false;
    saveState();
  }

  // ── Navigation ──
  function nextStep(current) {
    var next = current + 1;
    if (current === 1 && state.occasion === 'jga') next = 3;

    $('[data-step="' + current + '"]').classList.remove('active');
    $('[data-step="' + next + '"]').classList.add('active');
    state.step = next;
    updateProgress(next);
    if (next === 4) showResult();
    saveState();
    window.scrollTo({ top: root.offsetTop + 200, behavior: 'smooth' });
  }

  function prevStep(current) {
    var prev = current - 1;
    if (current === 3 && state.occasion === 'jga') prev = 1;

    $('[data-step="' + current + '"]').classList.remove('active');
    $('[data-step="' + prev + '"]').classList.add('active');
    state.step = prev;
    updateProgress(prev);
    saveState();
    window.scrollTo({ top: root.offsetTop + 200, behavior: 'smooth' });
  }

  function updateProgress(step) {
    $$('.ec-progress__step').forEach(function (s) {
      var sNum = parseInt(s.getAttribute('data-pstep'));
      s.classList.remove('active', 'completed');
      if (sNum === step) s.classList.add('active');
      if (sNum < step) s.classList.add('completed');
    });
    for (var i = 1; i <= 3; i++) {
      var line = $('#ec-line-' + i);
      if (line) line.classList.toggle('completed', step > i);
    }
    var step2Label = $('#ec-step2-label');
    if (step2Label) step2Label.textContent = state.occasion === 'jga' ? '—' : 'Gäste';
  }

  function toggleDetails(btn) {
    var content = btn.nextElementSibling;
    btn.classList.toggle('open');
    content.classList.toggle('open');
    var span = btn.querySelector('span');
    span.textContent = btn.classList.contains('open') ? 'Inhalt ausblenden' : 'Inhalt anzeigen';
  }

  // ── Show Result ──
  function showResult() {
    currentItems = getRecommendation();
    renderResult(currentItems);
    setupRatioSlider(currentItems);
  }

  function formatPrice(num) {
    return num.toFixed(2).replace('.', ',');
  }

  function renderResult(items) {
    var occasionText = state.occasion === 'jga' ? 'deinen JGA' : 'euren Hochzeitsempfang';
    var tasteMap = { sweet: 'Süß & Fruchtig', dry: 'Trocken & Klassisch', mixed: 'Gemischt' };
    var tasteText = tasteMap[state.taste];

    $('#ec-result-title').textContent = 'Perfekt für ' + occasionText;
    $('#ec-result-subtitle').textContent = 'Geschmack: ' + tasteText +
      (state.occasion === 'wedding' ? ' · Set-Größe: ' + state.guests.toUpperCase() : '');

    // JGA qty controls
    var jgaQtyEl = $('#ec-jga-qty-controls');
    if (state.occasion === 'jga') {
      var currentTotal = items.reduce(function (sum, i) { return sum + i.qty; }, 0);
      if (!jgaQtyEl) {
        jgaQtyEl = document.createElement('div');
        jgaQtyEl.id = 'ec-jga-qty-controls';
        jgaQtyEl.className = 'ec-jga-qty';
        $('#ec-result-subtitle').after(jgaQtyEl);
      }
      jgaQtyEl.innerHTML =
        '<span class="ec-jga-qty__label">Menge:</span>' +
        '<button type="button" class="ec-jga-qty__btn" onclick="ecSetJgaQty(-1)">−</button>' +
        '<span class="ec-jga-qty__value">' + currentTotal + '</span>' +
        '<button type="button" class="ec-jga-qty__btn" onclick="ecSetJgaQty(1)">+</button>' +
        '<span class="ec-jga-qty__unit">Karton(s)</span>';
      jgaQtyEl.style.display = 'flex';
    } else if (jgaQtyEl) {
      jgaQtyEl.style.display = 'none';
    }

    var setTitle = $('#ec-result-set-title');
    if (items.length === 1) {
      setTitle.textContent = items[0].qty > 1
        ? items[0].qty + '× ' + products[items[0].product].name
        : products[items[0].product].name;
    } else {
      setTitle.textContent = 'Dein individuelles Paket';
    }

    var totalPrice = 0, totalCompare = 0, totalPiccolos = 0;
    var hugoBoxes = 0;
    var totalBoxes = 0;
    var html = '';

    items.forEach(function (item) {
      var p = products[item.product];
      var price = p.pricePerBox * item.qty;
      var compare = p.comparePricePerBox * item.qty;
      totalPrice += price;
      totalCompare += compare;
      var itemPiccolos = item.qty * 24;
      totalPiccolos += itemPiccolos;
      totalBoxes += item.qty;
      if (item.product === 'hugo') hugoBoxes += item.qty;

      var litersPerBox = 24 * 0.2;
      var pricePerLiter = p.pricePerBox / litersPerBox;

      var contentsHtml = p.contents.map(function (c) {
        var totalQty = c.baseQty * item.qty;
        return '<div class="ec-content-line">' +
          '<img class="ec-content-line__img" src="' + c.img + '" alt="' + c.name + '">' +
          '<div>' +
            '<div class="ec-content-line__text">' + totalQty + '× ' + c.name + '</div>' +
            '<div class="ec-content-line__sub">' + c.detail + '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      html += '<div class="ec-item">' +
        '<div class="ec-item__top">' +
          '<div class="ec-item__left">' +
            (p.img ? '<img class="ec-item__img" src="' + p.img + '" alt="' + p.name + '">' : '') +
            '<div>' +
              '<div class="ec-item__name">' + p.name + '</div>' +
              '<div class="ec-item__desc">' + p.shortDesc + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="ec-item__right">' +
            '<div class="ec-item__qty">' + item.qty + '× · ' + formatPrice(p.pricePerBox) + ' € / Karton</div>' +
            '<div class="ec-item__meta">' + formatPrice(pricePerLiter) + ' € / Liter</div>' +
            '<div class="ec-item__meta">' + itemPiccolos + ' Piccolos</div>' +
          '</div>' +
        '</div>' +
        '<div class="ec-details">' +
          '<button type="button" class="ec-details__toggle" onclick="window.ecToggleDetails(this)">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>' +
            '<span>Inhalt anzeigen</span>' +
          '</button>' +
          '<div class="ec-details__content">' + contentsHtml + '</div>' +
        '</div>' +
      '</div>';
    });

    // Gratis: Strohhalmset (nur wenn aktiviert)
    var strawQty = Math.ceil(totalPiccolos / 50);
    if (strawQty > 0 && cfg.strawEnabled && cfg.strawVariantId) {
      html += '<div class="ec-item ec-item--gratis">' +
        '<div class="ec-item__top">' +
          '<div class="ec-item__left">' +
            '<img class="ec-gratis__img" src="' + cfg.gratisStrawImg + '" alt="Strohhalmset">' +
            '<div class="ec-item__name">' + cfg.gratisStrawName + '</div>' +
          '</div>' +
          '<div class="ec-item__qty ec-item__qty--gratis">' + strawQty + '× · GRATIS</div>' +
        '</div>' +
      '</div>';
    }

    // Gratis: Piccolo Puncher (nur wenn aktiviert)
    if (hugoBoxes > 0 && cfg.puncherEnabled && cfg.puncherVariantId) {
      html += '<div class="ec-item ec-item--gratis">' +
        '<div class="ec-item__top">' +
          '<div class="ec-item__left">' +
            '<img class="ec-gratis__img" src="' + cfg.gratisPuncherImg + '" alt="Piccolo Puncher">' +
            '<div class="ec-item__name">' + cfg.gratisPuncherName + '</div>' +
          '</div>' +
          '<div class="ec-item__qty ec-item__qty--gratis">' + hugoBoxes + '× · GRATIS</div>' +
        '</div>' +
      '</div>';
    }

    $('#ec-result-items').innerHTML = html;

    // ── Volume Discount ──
    var discountTiers = cfg.discountTiers || [
      { min: 2, pct: 2 },
      { min: 4, pct: 4 },
      { min: 10, pct: 10 }
    ];

    var activeDiscount = 0;
    discountTiers.forEach(function (tier) {
      if (totalBoxes >= tier.min) activeDiscount = tier.pct;
    });

    var discountAmount = 0;
    if (activeDiscount > 0) {
      discountAmount = totalPrice * (activeDiscount / 100);
      totalPrice = totalPrice - discountAmount;
    }

    var tiersHtml = '<div class="ec-discount">' +
      '<div class="ec-discount__title">Mengenrabatt</div>' +
      '<div class="ec-discount__tiers">';

    discountTiers.forEach(function (tier) {
      var isActive = totalBoxes >= tier.min;
      var isCurrentTier = activeDiscount === tier.pct;
      tiersHtml += '<div class="ec-discount__tier' +
        (isActive ? ' ec-discount__tier--active' : '') +
        (isCurrentTier ? ' ec-discount__tier--current' : '') +
        '" onclick="ecSetTotalBoxes(' + tier.min + ')">' +
        '<span class="ec-discount__tier-pct">' + tier.pct + '%</span>' +
        '<span class="ec-discount__tier-label">ab ' + tier.min + ' Kartons</span>' +
      '</div>';
    });

    tiersHtml += '</div>';

    if (activeDiscount > 0) {
      tiersHtml += '<div class="ec-discount__active">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
        activeDiscount + '% Mengenrabatt aktiv — du sparst ' + formatPrice(discountAmount) + ' € extra!' +
      '</div>';
    } else {
      var nextTier = discountTiers[0];
      if (nextTier) {
        tiersHtml += '<div class="ec-discount__hint">' +
          'Noch ' + (nextTier.min - totalBoxes) + ' Karton(s) bis ' + nextTier.pct + '% Rabatt' +
        '</div>';
      }
    }

    tiersHtml += '</div>';

    var savings = totalCompare - totalPrice;

    var summaryHtml = tiersHtml +
      '<div class="ec-summary__row">' +
        '<span class="ec-summary__label">Gesamt Piccolos</span>' +
        '<span class="ec-summary__value">' + totalPiccolos + ' Stück</span>' +
      '</div>' +
      '<div class="ec-summary__row">' +
        '<span class="ec-summary__label">Statt</span>' +
        '<span class="ec-summary__value" style="text-decoration:line-through;color:var(--ec-text-muted);">' + formatPrice(totalCompare) + ' €</span>' +
      '</div>' +
      (activeDiscount > 0 ?
        '<div class="ec-summary__row">' +
          '<span class="ec-summary__label">Mengenrabatt (' + activeDiscount + '%)</span>' +
          '<span class="ec-summary__value" style="color:var(--ec-success);">−' + formatPrice(discountAmount) + ' €</span>' +
        '</div>' : '') +
      '<div class="ec-summary__row">' +
        '<span class="ec-summary__label">Versandkosten</span>' +
        '<span class="ec-summary__value" style="color:var(--ec-success);">Kostenlos</span>' +
      '</div>' +
      '<div class="ec-summary__row">' +
        '<span class="ec-summary__total-label">Gesamtpreis</span>' +
        '<div>' +
          '<span class="ec-summary__total-value">' + formatPrice(totalPrice) + ' €</span>' +
          '<div class="ec-savings">Du sparst ' + formatPrice(savings) + ' €</div>' +
        '</div>' +
      '</div>' +
      '<div class="ec-summary__legal">Alle Preise inkl. MwSt.</div>' +
      '<div class="ec-summary__customize" id="ec-customize-link" style="display:none;">' +
        '<button type="button" class="ec-customize-btn" onclick="ecToggleRatioSlider()">' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>' +
          'Auswahl anpassen' +
        '</button>' +
      '</div>';

    $('#ec-result-summary').innerHTML = summaryHtml;
    root.ecCurrentItems = currentItems;
  }

  // ── Ratio Slider ──
  function setupRatioSlider(items) {
    var wrap = $('#ec-ratio');
    var body = $('#ec-ratio-body');
    var slider = $('#ec-ratio-input');
    var customizeLink = $('#ec-customize-link');

    if (state.taste !== 'mixed' || items.length < 2) {
      wrap.classList.remove('visible');
      if (customizeLink) customizeLink.style.display = 'none';
      return;
    }

    wrap.classList.add('visible');
    body.classList.remove('open');
    if (customizeLink) customizeLink.style.display = 'block';

    totalBoxes = items.reduce(function (sum, i) { return sum + i.qty; }, 0);
    var premiumQty = 0;
    items.forEach(function (i) { if (i.product === 'premium') premiumQty = i.qty; });

    slider.max = totalBoxes;
    slider.value = premiumQty;
    updateRatioDisplay(premiumQty);
  }

  function toggleRatioSlider() {
    var body = $('#ec-ratio-body');
    body.classList.toggle('open');
  }

  function onRatioChange(val) {
    var premiumQty = parseInt(val);
    var hugoQty = totalBoxes - premiumQty;
    updateRatioDisplay(premiumQty);

    var newItems = [];
    if (premiumQty > 0) newItems.push({ product: 'premium', qty: premiumQty });
    if (hugoQty > 0) newItems.push({ product: 'hugo', qty: hugoQty });

    currentItems = newItems;
    renderResult(newItems);
    saveState();

    $('#ec-ratio').classList.add('visible');
    $('#ec-ratio-body').classList.add('open');
    var cl = $('#ec-customize-link');
    if (cl) cl.style.display = 'block';
    $('#ec-ratio-input').max = totalBoxes;
    $('#ec-ratio-input').value = premiumQty;
  }

  function updateRatioDisplay(premiumQty) {
    var hugoQty = totalBoxes - premiumQty;
    $('#ec-ratio-premium-qty').textContent = premiumQty;
    $('#ec-ratio-hugo-qty').textContent = hugoQty;

    var pct = totalBoxes > 0 ? (premiumQty / totalBoxes) * 100 : 50;
    $('#ec-ratio-bar-left').style.width = pct + '%';
    $('#ec-ratio-bar-right').style.width = (100 - pct) + '%';

    var slider = $('#ec-ratio-input');
    slider.style.background = 'linear-gradient(to right, var(--ec-accent) 0%, var(--ec-accent) ' + pct + '%, var(--ec-accent-light) ' + pct + '%, var(--ec-accent-light) 100%)';
  }

  function restart() {
    state.occasion = null;
    state.guests = null;
    state.taste = null;
    state.step = 1;
    currentItems = [];

    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}

    $$('.ec-option, .ec-guest').forEach(function (c) { c.classList.remove('selected'); });
    $$('.ec-btn--next').forEach(function (b) { b.disabled = true; });
    $$('.ec-step').forEach(function (s) { s.classList.remove('active'); });
    $('[data-step="1"]').classList.add('active');
    $('#ec-ratio').classList.remove('visible');
    updateProgress(1);
    window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
  }

  function goToStep(target) {
    if (target >= state.step) return;
    if (target === 2 && state.occasion === 'jga') return;

    $('[data-step="' + state.step + '"]').classList.remove('active');
    $('[data-step="' + target + '"]').classList.add('active');
    state.step = target;
    updateProgress(target);
    saveState();
    window.scrollTo({ top: root.offsetTop + 200, behavior: 'smooth' });
  }

  function setTotalBoxes(newTotal) {
    var taste = state.taste;
    var newItems = [];

    if (taste === 'sweet') {
      newItems = [{ product: 'hugo', qty: newTotal }];
    } else if (taste === 'dry') {
      newItems = [{ product: 'premium', qty: newTotal }];
    } else if (taste === 'mixed') {
      var pQty = Math.ceil(newTotal / 2);
      var hQty = Math.floor(newTotal / 2);
      if (pQty > 0) newItems.push({ product: 'premium', qty: pQty });
      if (hQty > 0) newItems.push({ product: 'hugo', qty: hQty });
    }

    currentItems = newItems;
    renderResult(newItems);
    setupRatioSlider(newItems);
    saveState();
  }

  function setJgaQty(delta) {
    var currentTotal = currentItems.reduce(function (sum, i) { return sum + i.qty; }, 0);
    var newTotal = Math.max(1, currentTotal + delta);
    setTotalBoxes(newTotal);
  }

  window.ecSelectOption = selectOption;
  window.ecNextStep = nextStep;
  window.ecPrevStep = prevStep;
  window.ecGoToStep = goToStep;
  window.ecToggleDetails = toggleDetails;
  window.ecToggleRatioSlider = toggleRatioSlider;
  window.ecOnRatioChange = onRatioChange;
  window.ecRestart = restart;
  window.ecSetTotalBoxes = setTotalBoxes;
  window.ecSetJgaQty = setJgaQty;

  // ══════════════════════════════════════════
  // ── Cart (2-Step: Hauptprodukte → Gratis) ──
  // ══════════════════════════════════════════
  var cartBtn = $('#ec-btn-cart');
  var isAddingToCart = false;

  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      if (isAddingToCart || !currentItems.length) return;

      var variantMap = {
        premium: cfg.premiumVariantId,
        hugo: cfg.hugoVariantId
      };

      // ── Hauptprodukte sammeln ──
      var mainItems = [];
      var missingIds = false;
      var totalPiccolos = 0;
      var hugoBoxes = 0;

      currentItems.forEach(function (item) {
        var variantId = variantMap[item.product];
        if (!variantId) { missingIds = true; return; }
        mainItems.push({ id: parseInt(variantId), quantity: item.qty });
        totalPiccolos += item.qty * 24;
        if (item.product === 'hugo') hugoBoxes += item.qty;
      });

      if (missingIds) {
        alert('Bitte Variant IDs im Theme Editor hinterlegen.');
        return;
      }

      // ── Gratis-Artikel sammeln (werden separat gesendet) ──
      var gratisItems = [];

      if (cfg.strawVariantId && cfg.strawEnabled && totalPiccolos > 0) {
        gratisItems.push({
          id: parseInt(cfg.strawVariantId),
          quantity: Math.ceil(totalPiccolos / 50)
        });
      }

      if (cfg.puncherVariantId && cfg.puncherEnabled && hugoBoxes > 0) {
        gratisItems.push({
          id: parseInt(cfg.puncherVariantId),
          quantity: hugoBoxes
        });
      }

      // Loading state
      isAddingToCart = true;
      cartBtn.disabled = true;
      cartBtn.innerHTML =
        '<svg class="ec-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>' +
        'Wird hinzugefügt...';

      // Gratis-Flags für den Sync speichern
      try {
        sessionStorage.setItem('ec-gratis-active', '1');
        sessionStorage.setItem('ec-puncher-enabled', cfg.puncherEnabled ? '1' : '0');
        sessionStorage.setItem('ec-straw-enabled', cfg.strawEnabled ? '1' : '0');
      } catch (e) {}

      // ── Step 1: Hauptprodukte ──
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: mainItems })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error: ' + res.status);
        return res.json();
      })
      .then(function () {
        // ── Step 2: Gratis-Artikel separat (Fehler blockiert nicht) ──
        if (gratisItems.length > 0) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: gratisItems })
          })
          .then(function (res) {
            if (!res.ok) {
              console.warn('Gratis-Artikel konnten nicht hinzugefügt werden (Status ' + res.status + ').');
            }
          })
          .catch(function (err) {
            console.warn('Gratis-Artikel fehlgeschlagen:', err.message);
          });
        }
      })
      .then(function () {
        // Success
        cartBtn.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>' +
          'Hinzugefügt!';
        cartBtn.style.background = 'var(--ec-success)';

        document.dispatchEvent(new CustomEvent('theme:cart:added'));
        refreshCartUI();

        setTimeout(function () {
          cartBtn.disabled = false;
          cartBtn.style.background = '';
          cartBtn.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            cfg.cartButtonText;
          isAddingToCart = false;
        }, 1500);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        cartBtn.disabled = false;
        cartBtn.style.background = '#c0392b';
        cartBtn.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>' +
          'Fehler — bitte erneut versuchen';
        isAddingToCart = false;

        setTimeout(function () {
          cartBtn.style.background = '';
          cartBtn.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            cfg.cartButtonText;
        }, 3000);
      });
    });
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartDrawer.renderContents(cart); })
        .catch(function () {});
    }
  }

  if (loadState()) {
    restoreUI();
  }

  // ── Upsell Add-to-Cart ──
  root.querySelectorAll('.ec-upsell__atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-upsell-variant');
      if (!variantId || btn.classList.contains('adding')) return;

      btn.classList.add('adding');
      btn.innerHTML = '<svg class="ec-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('adding');
        btn.classList.add('added');
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';

        document.dispatchEvent(new CustomEvent('theme:cart:change'));
        document.dispatchEvent(new CustomEvent('theme:cart:added'));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { cartDrawer.renderContents(cart); })
            .catch(function () {});
        }

        setTimeout(function () {
          btn.classList.remove('added');
          btn.innerHTML = '';
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('adding');
        btn.innerHTML = '';
      });
    });
  });

})();